/* ---------------------------------------------------------------------
 *                           Import Packages
 * --------------------------------------------------------------------- */

// React
import React from "react";

// MUI
import { Box, Typography, Divider } from "@mui/material";
/* ---------------------------------------------------------------------
 *                             Error Component
 * --------------------------------------------------------------------- */

/**
 * 定义404错误页面
 * @returns 错误页面
 * @function Error
 * @static
 */
export default function Error() {
  /* ---------------------------------------------------------------------
   *                            Render Component
   * --------------------------------------------------------------------- */

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        paddingTop: "80px",
        background: "#fff",
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: "80px",
          fontWeight: 600,
          marginBottom: "16px",
        }}
      >
        404 Not Found
      </Typography>
      <Divider
        sx={{
          width: "280px",
          margin: "8px auto",
          borderTop: "2px solid #ccc",
        }}
      />
      <Typography
        variant="body1"
        sx={{
          fontSize: "20px",
          color: "#555",
        }}
      >
        nginx
      </Typography>
    </Box>
  );
}
